import { checkCRUD } from "./check";
import { folderCRUD } from "./folder";

export const CRUDAPI = {
  checkCRUD,
  folderCRUD,
};
